﻿'use strict';

angular.module('ntmApp').factory('Recurrence', ['Constants', function (Constants) {

    function Recurrence() {

        var self = this;

        var DEFAULT_VALUES = {
            timesPerDay: 1,
            date: null,
            everyNumbersOfWeeks: 1,
            everyNumbersOfDays: 2,
            biweeklyWeekNumber: Constants.Recurrence.Patterns.WEEKLY.Options.Biweekly_Cycle.Options.Week1.value,
            scheduleRacksEveryWeekNumber: 1,
            scheduleRacksEveryMonthNumber: 1,
            scheduleRacksEveryYearNumber: 1,
            dayYearOnAnniversaryType: 1,
            schedulingLeeway: 0,
            rackItemWeekNumber: 1,
            rackItemMonthNumber: 1,
            monthItem: Constants.Months.January,
            monthlyDayItem: Constants.Recurrence.MonthlyDays.WEEKDAY,
            monthlyDayPrefix: Constants.Recurrence.DayPrefixes.FIRST,
            everyHoursInterval: 0,
            totalTimeRange: 0,
            sharedOption: {value: null, name: 'Please select'}
        };

        self.displayTimePattern = function () {

            if (!self.whenOption) {
                return;
            }

            switch (parseInt(self.whenOption.value)) {
                case Constants.Recurrence.WhenOptions.ANYTIME.value:
                case Constants.Recurrence.WhenOptions.AM.value:
                case Constants.Recurrence.WhenOptions.PM.value:
                case Constants.Recurrence.WhenOptions.MIDDAY.value:
                    return 'ng1/src/setup/recurrence/templates/when/when_anytime_am_pm_midday.html';
                case Constants.Recurrence.WhenOptions.SPECIFIC_TIME.value:
                    return 'ng1/src/setup/recurrence/templates/when/specific_time.html';
                case Constants.Recurrence.WhenOptions.TIME_INTERVALS.value:
                    return 'ng1/src/setup/recurrence/templates/when/time_intervals.html';
            }
        };

        self.applyRecurrenceInfo = function (data) {

            self.patternType = parseInt(data.patternType);
            self.whenOption = Constants.Recurrence.WhenOptions.getByValue(parseInt(data.amOrPmType));
            self.timesPerDay = { value: parseInt(data.timesNumber) };
            self.specificTime = { value: data.time && moment(data.time, 'hh:mm A').isValid() ? moment(data.time, 'hh:mm A') : moment().startOf('day'),isTimeValue:true };
            self.startTime = { value: data.time && moment(data.time, 'hh:mm A').isValid() ? moment(data.time, 'hh:mm A') : moment().startOf('day'), isTimeValue: true };
            self.everyHoursInterval = { value: data.timeIntervalsEvery };
            self.totalTimeRange = { value: data.timeRange };
            self.startsOnDate = { value: data.dateStart ? new Date(data.dateStart) : null };
            self.occurenceYearlyType = data.occursYearlyType ? data.occursYearlyType : Constants.Recurrence.Patterns.YEARLY.Options.On_Anniversary.value;
            self.everyNumbersOfWeeks = { value: parseInt(data.everyWeekly) };
            self.everyNumbersOfDays = { value: parseInt(data.everyDaily) };
            self.everyNumbersOfMonths = parseInt(data.everyMonthly);
            self.everyNumbersOfYears = { value: parseInt(data.everyYearly) };
            self.biweeklyWeekNumber = data.biweeklyNumber ? data.biweeklyNumber : Constants.Recurrence.Patterns.WEEKLY.Options.Biweekly_Cycle.Options.Week1.value;
            self.monthDayMonthlyType = Constants.Recurrence.MonthlyDays.getByValue(parseInt(data.monthDayMonthlyType));
            self.monthNumberMonthlyType = Constants.Recurrence.DayPrefixes.getByValue(parseInt(data.monthNumberMonthlyType));
            self.monthDayYearlyType = Constants.Recurrence.MonthlyDays.getByValue(parseInt(data.monthDayYearlyType));
            self.monthNumberYearlyType = Constants.Recurrence.DayPrefixes.getByValue(parseInt(data.monthNumberYearlyType));
            self.dayYearOnAnniversaryType = { value: data.yearDay };
            self.monthYearOnAnniversaryType = Constants.Months.getByValue(parseInt(data.monthYearOnAnniversaryType));
            self.monthYearOnSelectionType = Constants.Months.getByValue(parseInt(data.monthYearOnSelectionType));
            self.afterLeeway = { value: parseInt(data.afterLeeway) };
            self.beforeLeeway = { value: parseInt(data.beforeLeeway) };
            self.occurenceLimitEndsOnDate = { value: data.dateEnd ? new Date(data.dateEnd) : null };
            self.scheduleRacksEveryWeekNumber = { value: parseInt(data.everyWeekly) };
            self.scheduleRacksEveryMonthNumber = { value: parseInt(data.everyMonthly) };
            self.scheduleRacksEveryYearNumber = { value: parseInt(data.everyYearly) };
            self.sharedOptions = data.sharedPatternItems;

            self.sharedOption = data.selectedSharedItem ? data.sharedPatternItems.filter(item => item.value === data.selectedSharedItem)[0] : self.sharedOption;

            if (self.setSpecificValues) {
                self.setSpecificValues(data);
            }   

            self.applyGeneralDefaultInfo(data);
        };

        self.applyGeneralDefaultInfo = function (data) {
            self.recurrenceId = data.recurrenceId;
            self.setupType = data.setupType;
            self.isFirtTimeLoaded = !data.reccurText ? true : false;
            self.dialogId = data.dialogId;
            self.scheduleRacks = (data.rackSplit === "Yes" && data.isScheduleRack) ? "true" : "false";
            self.selectedSchdeduleRacksOption = Constants.Recurrence.ScheduleRacksOptions.getByValue(self.scheduleRacks); //temporary solution
            self.allowScheduleRacks = data.isScheduleRack;
            self.nonCageRackActivityCount = data.nonCageRackActivityCount;

            self.allowSetupRacks = self.isSettingUpRacksAllowed(data.setupType);
            self.rackItems = getRackInfo(data.recurrenceRacks);
            self.isScheduleRack =  data.isScheduleRack ;

            setDefaultValues();
            setDefaultRackItemsValues(self.rackItems);
            setFieldsRestricts();
            setRackFieldsRestricts(self.rackItems);

            if (data.isSharedRecurrence) {
                resetWhenAndPerOptions();
            }
        };

        self.scheduleRacksOnDiffDays = function () {
            return self.scheduleRacks === 'yes' || self.scheduleRacks === 'true';
        };

        self.isSettingUpRacksAllowed = function (setupType) {
            return setupType === Constants.Recurrence.RecurrenceActivitySetup.RoomActivity.value || setupType === Constants.Recurrence.RecurrenceActivitySetup.SharedRecurrence.value;
        };

        self.getRackItemLabel = function (rackItem) {
            return '{0} ({1} {2}):'.format(rackItem.rackId, ((rackItem.cageCount === null || rackItem.cageCount === undefined) ? "<i>missing</i>" : rackItem.cageCount), rackItem.rackItemName);
        };

        self.getGeneralFieldsListForSave = function () {

            var generalFieldsList = {};
            generalFieldsList.occurenceLimitEndsOnDate = self.occurenceLimitEndsOnDate;

            if (self.whenOption) {
                switch (parseInt(self.whenOption.value)) {
                    case Constants.Recurrence.WhenOptions.SPECIFIC_TIME.value:
                        generalFieldsList.specificTime = self.specificTime;
                        break;
                    case Constants.Recurrence.WhenOptions.TIME_INTERVALS.value:
                        generalFieldsList.startTime = self.startTime;
                        generalFieldsList.everyHoursInterval = self.everyHoursInterval;
                        generalFieldsList.totalTimeRange = self.totalTimeRange;
                        break;
                    default:
                        generalFieldsList.timesPerDay = self.timesPerDay;
                        break;
                }
            }

            return generalFieldsList;
        };

        self.getGeneralRequestData = function () {
            var request = {
                recurrenceId: self.recurrenceId,
                setupType: self.setupType,
                dialogId: self.dialogId,
                rackSplit: self.scheduleRacksOnDiffDays() ? "Yes" : "No",
                patternType: parseInt(self.patternType),
                amOrPmType: self.whenOption ? parseInt(self.whenOption.value) : null,
                isScheduleRack: self.isScheduleRack,
                dateEnd: self.occurenceLimitEndsOnDate.value
            };

            if (self.whenOption) {
                switch (parseInt(self.whenOption.value)) {
                    case Constants.Recurrence.WhenOptions.SPECIFIC_TIME.value:
                        request.time = self.specificTime && self.specificTime.value && moment(self.specificTime.value).isValid() ? moment(self.specificTime.value).format("hh:mm A") : null;
                        break;
                    case Constants.Recurrence.WhenOptions.TIME_INTERVALS.value:
                        request.time = self.startTime && self.startTime.value && moment(self.startTime.value).isValid() ? moment(self.startTime.value).format("hh:mm A") : null;
                        request.timeIntervalsEvery = self.everyHoursInterval.value;
                        request.timeRange = self.totalTimeRange.value;
                        break;
                    default:
                        request.timesNumber = self.timesPerDay.value;
                        break;
                }
            }

            return request;
        };

        self.getWeekDayDictionaryBySelectedDays = function (selectedDays) {

            var dictionary = {};

            Constants.DayLabels.labels.forEach(function (dayLabel) {

                var isSelected = selectedDays.some(function (selectedItem) {
                    return dayLabel.dayOfWeek === selectedItem.dayOfWeek;
                });

                dictionary[dayLabel.label] = isSelected;

            });

            return dictionary;
        };

        self.getSelectedDaysFromDictionary = function (daysDictionary) {

            return Constants.DayLabels.labels.filter(function (label) {
                return daysDictionary[label.label.toLowerCase()];
            });

        };

        self.compareGeneralInfo = function (recurrence) {

            if (parseInt(self.patternType) !== parseInt(recurrence.patternType)) {
                return false;
            }

            if (self.whenOption && parseInt(self.whenOption.value) !== parseInt(recurrence.whenOption.value)) {
                return false;
            }

            if (!self.whenOption) {
                return true;
            }

            switch (parseInt(self.whenOption.value)) {
                case Constants.Recurrence.WhenOptions.SPECIFIC_TIME.value:

                    if (!moment(moment(self.specificTime.value), 'hh:mm').isSame(moment(moment(recurrence.specificTime.value), 'hh:mm'))) {
                        return false;
                    }

                    break;
                case Constants.Recurrence.WhenOptions.TIME_INTERVALS.value:

                    if (!moment(moment(self.startTime.value), 'hh:mm').isSame(moment(moment(recurrence.startTime.value), 'hh:mm'))) {
                        return false;
                    }

                    if (parseInt(self.everyHoursInterval.value) !== parseInt(recurrence.everyHoursInterval.value)) {
                        return false;
                    }

                    if (parseInt(self.totalTimeRange.value) !== parseInt(recurrence.totalTimeRange.value)) {
                        return false;
                    }

                    break;
                default:

                    if (parseInt(self.timesPerDay.value) !== parseInt(recurrence.timesPerDay.value)) {
                        return false;
                    }

                    break;
            }

            return true;
        };

        self.compareSelectedDays = function (days1, days2) {

            if (days1.length !== days2.length) {
                return false;
            }

            var compareSelectedDaysAction = function (day) {
                return day.dayOfWeek === days1[i].dayOfWeek;
            };

            for (var i = 0; i < days1.length; i++) {

                if (!days2.some(compareSelectedDaysAction)) {
                    return false;
                }
            }

            return true;
        };

        self.areDaysEqual = function (newDay, originalDay) {
            if ((moment(newDay).isValid()) && (moment(originalDay).isValid())) {

                if (!moment(newDay).isSame(moment(originalDay), 'days')) {
                    return false;
                }
            }
            else if (((moment(newDay).isValid()) && (!moment(originalDay).isValid())) ||
                ((!moment(newDay).isValid()) && (moment(originalDay).isValid()))) {

                return false;
            }

            return true;
        };

        self.areFieldsValid = function () {
            var fields = self.getFieldsListForSave();
            var areFieldsValid = true;

            //specific validation section
            if (self.whenOption && parseInt(self.whenOption.value) === Constants.Recurrence.WhenOptions.TIME_INTERVALS.value) {
                var startTimeValue = moment(self.startTime.value);
                var nextDayValue = moment(self.startTime.value).add(1, 'day');
                var startTimeAndTotalTimeRange = moment(startTimeValue).add(self.totalTimeRange.value, 'hours');
                var doesTotalTimeRangeFitSameDay = moment(startTimeAndTotalTimeRange).isBefore(nextDayValue, 'day');

                if (!doesTotalTimeRangeFitSameDay) {
                    self.totalTimeRange.hasValidationError = true;
                    areFieldsValid = false;
                }

                if (self.everyHoursInterval.value > self.totalTimeRange.value) {
                    self.everyHoursInterval.hasValidationError = true;
                    self.totalTimeRange.hasValidationError = true;
                    areFieldsValid = false;
                }
            }

            for (var prop in fields) {

                if (fields.hasOwnProperty(prop) && fields[prop]) {

                    if (fields[prop].restricts) {

                        if (self.checkForDynamicRestricts) {
                            self.checkForDynamicRestricts(fields[prop], prop);
                        }

                        if (!(fields[prop].restricts.allowNullable) && (!(fields[prop].value) || (fields[prop].value === ''))) {
                            if (parseInt(fields[prop].value) !== 0) {
                                fields[prop].hasValidationError = true;
                                areFieldsValid = false;
                            }
                        }

                        if ((fields[prop].restricts.minValue) && (fields[prop].value < fields[prop].restricts.minValue)) {
                            fields[prop].hasValidationError = true;
                            areFieldsValid = false;
                        }

                        if ((fields[prop].restricts.maxValue) && (fields[prop].value > fields[prop].restricts.maxValue)) {
                            fields[prop].hasValidationError = true;
                            areFieldsValid = false;
                        }

                        if (fields[prop].restricts.shouldBeDate) {
                            if (fields[prop].restricts.allowNullable) {
                                if ((fields[prop].value !== null) && (fields[prop].value !== '')) {
                                    if (fields[prop].value === undefined || !(moment(fields[prop].value).isValid())) {
                                        fields[prop].hasValidationError = true;
                                        areFieldsValid = false;
                                    }
                                }
                            }
                            else {
                                if (fields[prop].value === undefined || !(moment(fields[prop].value).isValid())) {
                                    fields[prop].hasValidationError = true;
                                    areFieldsValid = false;
                                }
                            }
                        }
                    }


                    if (fields[prop].isTimeValue) {
                        if (fields[prop].value === null || fields[prop].value === undefined) {
                            fields[prop].hasValidationError = true;
                                areFieldsValid = false;
                        }
                    }


                    if (prop === 'dateComposition' && fields.dateComposition) {

                        for (var i = 0; i < fields.dateComposition.length; i++) {
                            var newDate = moment([moment().year(), parseInt(fields.dateComposition[i].month.value), parseInt(fields.dateComposition[i].day.value)]);

                            if (!(moment(newDate).isValid())) {
                                fields.dateComposition[i].day.hasValidationError = true;
                                areFieldsValid = false;
                            }
                        }
                    }

                    if (prop === 'dateStartAndDateEnd' && fields.dateStartAndDateEnd) {

                        for (var it = 0; it < fields.dateStartAndDateEnd.length; it++) {
                            var momentDateStart = moment(fields.dateStartAndDateEnd[it].dateStart.value);
                            var momentDateEnd = moment(fields.dateStartAndDateEnd[it].dateEnd.value);

                            var isMomentBefore = moment(momentDateStart).isBefore(momentDateEnd, 'day');

                            if (!isMomentBefore) {
                                fields.dateStartAndDateEnd[it].dateStart.hasValidationError = true;
                                fields.dateStartAndDateEnd[it].dateEnd.hasValidationError = true;
                                areFieldsValid = false;
                            }
                        }
                    }

                    if (prop === 'weekDays' && fields.weekDays) {

                        var selectedWeekDaysCount = 0;

                        for (var weekDay in fields.weekDays) {
                            if (fields.weekDays.hasOwnProperty(weekDay) && fields.weekDays[weekDay]) {
                                selectedWeekDaysCount += 1;
                            }
                        }

                        if (!selectedWeekDaysCount || fields.weekDays.length === 0) {
                            self.hasWeekDaysError = true;
                            areFieldsValid = false;
                        } else {
                            self.hasWeekDaysError = false;
                        }
                    }

                    if (prop === 'recurrenceRacks' && fields.recurrenceRacks && self.allowSetupRacks) {

                        for (var item = 0; item < fields.recurrenceRacks.length; item++) {
                            var rackItem = fields.recurrenceRacks[item];

                            for (var rackProp in rackItem) {

                                if (rackItem.hasOwnProperty(rackProp) && rackItem[rackProp]) {

                                    if (rackItem[rackProp].restricts) {
                                        if ((rackItem[rackProp].restricts.minValue) && (rackItem[rackProp].value < rackItem[rackProp].restricts.minValue)) {
                                            rackItem[rackProp].hasValidationError = true;
                                            areFieldsValid = false;
                                        }

                                        if ((rackItem[rackProp].restricts.maxValue) && (rackItem[rackProp].value > rackItem[rackProp].restricts.maxValue)) {
                                            rackItem[rackProp].hasValidationError = true;
                                            areFieldsValid = false;
                                        }

                                        if (rackItem[rackProp].restricts.shouldBeDate) {
                                            if (rackItem[rackProp].restricts.allowNullable) {
                                                if ((rackItem[rackProp].value !== null) && (rackItem[rackProp].value !== '')) {
                                                    if (rackItem[rackProp].value === undefined || !(moment(rackItem[rackProp].value).isValid())) {
                                                        rackItem[rackProp].hasValidationError = true;
                                                        areFieldsValid = false;
                                                    }
                                                }
                                            }
                                            else {
                                                if (rackItem[rackProp].value === undefined || !(moment(rackItem[rackProp].value).isValid())) {
                                                    rackItem[rackProp].hasValidationError = true;
                                                    areFieldsValid = false;
                                                }
                                            }
                                        }
                                    }

                                    if (rackProp === 'dateStartAndDateEnd' && rackItem.dateStartAndDateEnd) {

                                        for (var iter = 0; iter < rackItem.dateStartAndDateEnd.length; iter++) {
                                            var rackItemMomentDateStart = moment(rackItem.dateStartAndDateEnd[iter].dateStart.value);
                                            var rackItemMomentDateEnd = moment(rackItem.dateStartAndDateEnd[iter].dateEnd.value);

                                            var isRackItemMomentBefore = moment(rackItemMomentDateStart).isBefore(rackItemMomentDateEnd, 'day');

                                            if (!isRackItemMomentBefore) {
                                                rackItem.dateStartAndDateEnd[iter].dateStart.hasValidationError = true;
                                                rackItem.dateStartAndDateEnd[iter].dateEnd.hasValidationError = true;
                                                areFieldsValid = false;
                                            }
                                        }
                                    }

                                    if (rackProp === 'weekDays' && rackItem.weekDays) {

                                        var rackItemSelectedWeekDaysCount = 0;

                                        for (var rackItemWeekDay in rackItem.weekDays) {
                                            if (rackItem.weekDays.hasOwnProperty(rackItemWeekDay) && rackItem.weekDays[rackItemWeekDay]) {
                                                rackItemSelectedWeekDaysCount += 1;
                                            }
                                        }

                                        if (!rackItemSelectedWeekDaysCount || rackItem.weekDays.length === 0) {
                                            self.rackItems[item].hasWeekDaysError = true;
                                            areFieldsValid = false;
                                        } else {
                                            self.rackItems[item].hasWeekDaysError = false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return areFieldsValid;
        };

        self.resetRackWeekMonthNumbers = function () {

            if (self.rackItems) {

                for (var i = 0; i < self.rackItems.length; i++) {

                    if (self.rackItems[i].weekNumber) {
                        self.rackItems[i].weekNumber.value = DEFAULT_VALUES.rackItemWeekNumber;
                        self.rackItems[i].weekNumber.restricts = {
                            minValue: 1,
                            maxValue: self.scheduleRacksEveryWeekNumber.value >= 1 ? self.scheduleRacksEveryWeekNumber.value : 1
                        };
                    }
                }
            }
        };

        self.setOriginalValues = function (originalRecurrence) {

            for (var prop in originalRecurrence) {
                if ((originalRecurrence.hasOwnProperty(prop)) && (originalRecurrence[prop] !== undefined) && (originalRecurrence[prop] !== null) && (typeof originalRecurrence[prop] !== 'function')) {
                    if ((self.hasOwnProperty(prop)) && (self[prop] !== undefined) && (self[prop] !== null)) {
                        self[prop] = angular.copy(originalRecurrence[prop]);
                    } else {
                        self[prop] = angular.copy(originalRecurrence[prop]);
                    }
                }
            }
        };

        self.getTimeIntervalsPreviewText = function () {

            if (isTimeIntervalsPreviewReady()) {
                var endTime = (moment(self.startTime.value)).add(self.totalTimeRange.value, 'hours');
                var tempPreviousTime = moment(self.startTime.value);
                var tempNextTime = moment(self.startTime.value);
                var tempNextDay = moment(self.startTime.value).add(1, 'day');

                var timeIntervalsPreviewString = '';

                timeIntervalsPreviewString += moment(self.startTime.value).format('hh:mm A');

                do {
                    var everyHoursIntervalHours = self.everyHoursInterval.value;
                    tempPreviousTime = moment(tempPreviousTime).add(everyHoursIntervalHours, 'hours');
                    timeIntervalsPreviewString += ', ' + moment(tempPreviousTime).format('hh:mm A');

                    tempNextTime = (moment(tempPreviousTime)).add(self.everyHoursInterval.value, 'hours');
                }
                while (((tempNextTime).isBefore(endTime) || (tempNextTime).isSame(endTime)) && (tempNextTime.isBefore(tempNextDay, 'day')));

                return timeIntervalsPreviewString;
            }

            return '';
        };

        function isTimeIntervalsPreviewReady() {
            return self.startTime && self.startTime.value && self.everyHoursInterval && self.everyHoursInterval.value && angular.isNumber(self.everyHoursInterval.value) && self.totalTimeRange && self.totalTimeRange.value && angular.isNumber(self.totalTimeRange.value) && self.everyHoursInterval.value <= self.totalTimeRange.value;
        }

        function setRackFieldsRestricts(rackItems) {

            if (rackItems) {

                rackItems.forEach(function (rackItem) {

                    rackItem.weekNumber.restricts = {
                        minValue: 1,
                        maxValue: self.scheduleRacksEveryWeekNumber.value >= 1 ? self.scheduleRacksEveryWeekNumber.value : 1
                    };

                    rackItem.everyNumbersOfDays.restricts = {
                        minValue: 2,
                        maxValue: 99
                    };

                    rackItem.startsOnDate.restricts = {
                        shouldBeDate: true,
                        allowNullable: false
                    };

                });
            }
        }

        function setFieldsRestricts() {

            self.timesPerDay.restricts = {
                minValue: 1,
                maxValue: 99999
            };

            self.everyNumbersOfWeeks.restricts = {
                minValue: 1,
                maxValue: 99
            };
            self.everyNumbersOfYears.restricts = self.everyNumbersOfWeeks.restricts;
            self.scheduleRacksEveryWeekNumber.restricts = self.everyNumbersOfWeeks.restricts;
            self.scheduleRacksEveryMonthNumber.restricts = self.everyNumbersOfWeeks.restricts;
            self.scheduleRacksEveryYearNumber.restricts = self.everyNumbersOfWeeks.restricts;

            self.everyNumbersOfDays.restricts = {
                minValue: 2,
                maxValue: 99
            };

            self.dayYearOnAnniversaryType.restricts = {
                minValue: 1,
                maxValue: 31
            };

            self.afterLeeway.restricts = {
                minValue: 0,
                maxValue: 9999999999
            };
            self.beforeLeeway.restricts = self.afterLeeway.restricts;

            if (self.startsOnDate) {
                self.startsOnDate.restricts = {
                    shouldBeDate: true,
                    allowNullable: true
                };
            }
            else {
                self.startsOnDate = {
                    restricts: {
                        shouldBeDate: true,
                        allowNullable: true
                    }
                };
            }

            if (self.occurenceLimitEndsOnDate) {
                self.occurenceLimitEndsOnDate.restricts = {
                    shouldBeDate: true,
                    allowNullable: true
                };
            }
            else {
                self.occurenceLimitEndsOnDate = {
                    restricts: {
                        shouldBeDate: true,
                        allowNullable: true
                    }
                };
            }

            self.everyHoursInterval.restricts = {
                minValue: 0,
                maxValue: 24
            };
            self.totalTimeRange.restricts = self.everyHoursInterval.restricts;

            self.sharedOption.restricts = {};

        }

        function getRackInfo(rackItems) {

            if (rackItems) {

                return rackItems.map(function (item) {

                    return {
                        ccrackID: item.ccrackID,
                        rackId: item.rackId,
                        cageCount: item.cageCount,
                        rackItemName:item.rackItemName,
                        selectedDays: self.getSelectedDaysFromDictionary(item.weekDays),
                        weekNumber: { value: parseInt(item.weekNumber) },
                        weeklyCycleOption: Constants.Recurrence.Patterns.WEEKLY.Options.Weekly_Cycle.Options.getByValue(parseInt(item.weeklyCycleOption)),
                        everyNumbersOfDays: { value: item.everyDaily ? parseInt(item.everyDaily) : item.everyDaily },
                        startsOnDate: { value: item.dateStart ? new Date(item.dateStart) : null },
                        monthlyDayPrefix: Constants.Recurrence.DayPrefixes.getByValue(parseInt(item.monthNumberMonthlyType)),
                        monthlyDay: Constants.Recurrence.MonthlyDays.getByValue(parseInt(item.monthDayMonthlyType)),
                        yearlyDayPrefix: Constants.Recurrence.DayPrefixes.getByValue(parseInt(item.monthNumberYearlyType)),
                        yearlyDay: Constants.Recurrence.MonthlyDays.getByValue(parseInt(item.monthDayYearlyType)),
                        month: Constants.Months.getByValue(parseInt(item.monthYearType))
                    };
                });
            }

            return [];
        }

        function setDefaultRackItemsValues(rackItems) {

            if (rackItems) {
                rackItems.forEach(function (rackItem) {

                    if (self.setSpecificDefaultRackItemsInfo) {
                        self.setSpecificDefaultRackItemsInfo();
                    }

                    if (!rackItem.weekNumber) {
                        rackItem.weekNumber.value = DEFAULT_VALUES.rackItemWeekNumber;
                    }

                    if (!rackItem.weeklyCycleOption) {
                        rackItem.weeklyCycleOption = Constants.Recurrence.Patterns.WEEKLY.Options.Weekly_Cycle.Options.getByValue(parseInt(DEFAULT_VALUES.biweeklyWeekNumber));
                    }

                    if (!rackItem.everyNumbersOfDays) {
                        rackItem.everyNumbersOfDays = { value: DEFAULT_VALUES.everyNumbersOfDays };
                    } else if ((rackItem.everyNumbersOfDays && rackItem.everyNumbersOfDays.value === null)) {
                        rackItem.everyNumbersOfDays.value = DEFAULT_VALUES.everyNumbersOfDays;
                    }

                    if (!rackItem.startsOnDate || (rackItem.startsOnDate && !rackItem.startsOnDate.value)) {
                        rackItem.startsOnDate = { value: DEFAULT_VALUES.date };
                    } else if (rackItem.startsOnDate && !rackItem.startsOnDate.value) {
                        rackItem.startsOnDate.value = DEFAULT_VALUES.date;
                    }

                    if (!rackItem.monthlyDayPrefix) {
                        rackItem.monthlyDayPrefix = DEFAULT_VALUES.monthlyDayPrefix;
                    }
                    
                    if (!rackItem.monthlyDay) {
                        rackItem.monthlyDay = DEFAULT_VALUES.monthlyDayItem;
                    }

                    if (!rackItem.yearlyDayPrefix) {
                        rackItem.yearlyDayPrefix = DEFAULT_VALUES.monthlyDayPrefix;
                    }

                    if (!rackItem.yearlyDay) {
                        rackItem.yearlyDay = DEFAULT_VALUES.monthlyDayItem;
                    }

                    if (!rackItem.month) {
                        rackItem.month = DEFAULT_VALUES.monthItem;
                    }

                });
            }
        }

        function setDefaultValues() {

            if (self.setSpecificDefaultInfo) {
                self.setSpecificDefaultInfo();
            }

            if (!self.timesPerDay || (self.timesPerDay && self.timesPerDay.value === null)) {
                self.timesPerDay = { value: DEFAULT_VALUES.timesPerDay };
            }

            if (!self.startsOnDate || (self.startsOnDate && !self.startsOnDate.value)) {
                self.startsOnDate = { value: DEFAULT_VALUES.date };
            }

            if (!self.occurenceLimitEndsOnDate || (self.occurenceLimitEndsOnDate && !self.occurenceLimitEndsOnDate.value)) {
                self.occurenceLimitEndsOnDate = { value: DEFAULT_VALUES.date };
            }

            if (!self.biweeklyWeekNumber) {
                self.biweeklyWeekNumber = DEFAULT_VALUES.biweeklyWeekNumber;
            }

            if (!self.everyNumbersOfWeeks || (self.everyNumbersOfWeeks && self.everyNumbersOfWeeks.value === null)) {
                self.everyNumbersOfWeeks = { value: DEFAULT_VALUES.everyNumbersOfWeeks };
            }

            if (!self.everyNumbersOfDays || (self.everyNumbersOfDays && self.everyNumbersOfDays.value === null)) {
                self.everyNumbersOfDays = { value: DEFAULT_VALUES.everyNumbersOfDays };
            }

            if (!self.everyNumbersOfMonths) {
                self.everyNumbersOfMonths = DEFAULT_VALUES.everyNumbersOfWeeks;
            }

            if (!self.everyNumbersOfYears || (self.everyNumbersOfYears && self.everyNumbersOfYears.value === null)) {
                self.everyNumbersOfYears = { value: DEFAULT_VALUES.everyNumbersOfWeeks };
            }

            if (!self.scheduleRacksEveryWeekNumber || (self.scheduleRacksEveryWeekNumber && self.scheduleRacksEveryWeekNumber.value === null)) {
                self.scheduleRacksEveryWeekNumber = { value: DEFAULT_VALUES.scheduleRacksEveryWeekNumber };
            }

            if (!self.scheduleRacksEveryMonthNumber || (self.scheduleRacksEveryMonthNumber && self.scheduleRacksEveryMonthNumber.value === null)) {
                self.scheduleRacksEveryMonthNumber = { value: DEFAULT_VALUES.scheduleRacksEveryMonthNumber };
            }

            if (!self.scheduleRacksEveryYearNumber || (self.scheduleRacksEveryYearNumber && self.scheduleRacksEveryYearNumber.value === null)) {
                self.scheduleRacksEveryYearNumber = { value: DEFAULT_VALUES.scheduleRacksEveryYearNumber };
            }

            if (!self.dayYearOnAnniversaryType || (self.dayYearOnAnniversaryType && self.dayYearOnAnniversaryType.value === null)) {
                self.dayYearOnAnniversaryType = { value: DEFAULT_VALUES.dayYearOnAnniversaryType };
            }

            if (!self.afterLeeway || (self.afterLeeway && self.afterLeeway.value === null)) {
                self.afterLeeway = { value: DEFAULT_VALUES.schedulingLeeway };
            }

            if (!self.beforeLeeway || (self.beforeLeeway && self.beforeLeeway.value === null)) {
                self.beforeLeeway = { value: DEFAULT_VALUES.schedulingLeeway };
            }

            if (!self.monthYearOnAnniversaryType) {
                self.monthYearOnAnniversaryType = DEFAULT_VALUES.monthItem;
            }

            if (!self.monthYearOnSelectionType) {
                self.monthYearOnSelectionType = DEFAULT_VALUES.monthItem;
            }

            if (!self.monthDayMonthlyType) {
                self.monthDayMonthlyType = DEFAULT_VALUES.monthlyDayItem;
            }

            if (!self.monthDayYearlyType) {
                self.monthDayYearlyType = DEFAULT_VALUES.monthlyDayItem;
            }

            if (!self.monthNumberMonthlyType) {
                self.monthNumberMonthlyType = DEFAULT_VALUES.monthlyDayPrefix;
            }

            if (!self.monthNumberYearlyType) {
                self.monthNumberYearlyType = DEFAULT_VALUES.monthlyDayPrefix;
            }

            if (!self.everyHoursInterval || (self.everyHoursInterval && self.everyHoursInterval.value === null)) {
                self.everyHoursInterval = { value: DEFAULT_VALUES.everyHoursInterval };
            }

            if (!self.totalTimeRange || (self.totalTimeRange && self.totalTimeRange.value === null)) {
                self.totalTimeRange = { value: DEFAULT_VALUES.totalTimeRange };
            }

            if (!self.sharedOption || (self.sharedOption && self.sharedOption.value === undefined)) {
                self.sharedOption = DEFAULT_VALUES.sharedOption;
            }


        }

        function resetWhenAndPerOptions() {
            self.whenOption = null;
            self.timesPerDay.value = null;
        }

        function initialize() {
            self.whenOption = Constants.Recurrence.WhenOptions.getByValue(parseInt(Constants.Recurrence.WhenOptions.ANYTIME.value));
        }

        initialize();
    }

    return (Recurrence);

}]);